import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";

export const financialDealsFields = defineFieldConfigMap({
  // FIELD: is_recurring
  is_recurring: {
    type: "boolean",
    label: "Recurring",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    formSpan: 1,
    filterType: "exact",
    width: 100,
    minWidth: 80,
    maxWidth: 120,
    groupable: true,
    icon: "Repeat",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    savedViewMembership: [
      "all-deals",
      "sales-pipeline",
      "closed-deals",
      "won-deals",
      "deals-invoiced",
    ],
  },
  // FIELD: monthly_amount
  monthly_amount: {
    type: "number",
    label: "Monthly Amount",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    formSpan: 2,
    filterType: "range",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    placeholder: "0.00",
    icon: "DollarSign",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    savedViewMembership: [
      "closed-deals",
      "won-deals",
      "deals-invoiced",
      "recurring-revenue",
      "committed-revenue",
    ],
  },
  // FIELD: contract_term_months
  contract_term_months: {
    type: "number",
    label: "Contract Term (months)",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    formSpan: 1,
    filterType: "range",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    placeholder: "48",
    icon: "CalendarRange",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    savedViewMembership: ["recurring-revenue", "committed-revenue"],
  },
  // FIELD: is_committed
  is_committed: {
    type: "boolean",
    label: "Committed",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    formSpan: 1,
    filterType: "exact",
    width: 100,
    minWidth: 80,
    maxWidth: 120,
    groupable: true,
    icon: "CheckCircle",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    savedViewMembership: ["all-deals", "recurring-revenue"],
  },
  // FIELD: cost
  cost: {
    type: "number",
    label: "Cost",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 2,
    filterType: "range",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    placeholder: "0.00",
    icon: "DollarSign",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    savedViewMembership: ["deals-ready-to-invoice"],
  },
  // FIELD: margin_percentage
  margin_percentage: {
    type: "number",
    label: "Margin %",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 1,
    filterType: "range",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    validation: {
      min: 0,
      max: 100,
    },
    placeholder: "0-100",
    icon: "Percent",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
    savedViewMembership: ["deals-ready-to-invoice"],
  },
  // FIELD: estimated_hours
  estimated_hours: {
    type: "number",
    label: "Estimated Hours",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 2,
    filterType: "range",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    placeholder: "0.00",
    icon: "Clock",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "financial",
  },
});
